import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingFallback from './LoadingFallback';

// Fleet page shells (static imports — nested inside the lazy FleetLayout chunk boundary)
import Overview from '../fleet/Overview';
import Escalations from '../fleet/Escalations';
import Activity from '../fleet/Activity';
import Tasks from '../fleet/Tasks';
import Agents from '../fleet/Agents';
import TraceViewer from '../fleet/TraceViewer';
import BoundsPolicy from '../fleet/BoundsPolicy';
import Runtime from '../fleet/Runtime';
import FleetSettings from '../fleet/Settings';

const FleetLayout = lazy(() => import('../fleet/FleetLayout'));
const FleetConsole = lazy(() => import('../fleet/Console'));

export const fleetRoutes = (
  <>
    <Route path="/fleet/*" element={
      <Suspense fallback={<LoadingFallback />}>
        <FleetLayout />
      </Suspense>
    }>
      <Route index element={<Overview />} />
      <Route path="console" element={<FleetConsole />} />
      <Route path="escalations" element={<Escalations />} />
      <Route path="activity" element={<Activity />} />
      <Route path="tasks" element={<Tasks />} />
      <Route path="agents" element={<Agents />} />
      <Route path="trace" element={<TraceViewer />} />
      <Route path="bounds" element={<BoundsPolicy />} />
      <Route path="runtime" element={<Runtime />} />
      <Route path="settings" element={<FleetSettings />} />
    </Route>
  </>
);
